export default "__VITE_ASSET__44a433cf__"